import styled from 'styled-components';

import { colors, animation } from '../../styles/constants';

const { shortAnimationDuration, transitionTimingFn } = animation;

const ShareSvg = styled.svg`
  path {
    fill: ${colors.white};
    transition: fill ${shortAnimationDuration}ms ${transitionTimingFn};
  }

  &:hover,
  &:active,
  &:focus {
    path {
      fill: #cbf5fe;
    }
  }

  &:active {
    opacity: 0.9;
  }
`;

export default ShareSvg;
